import { FC } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLIC_KEY } from "../../utils/billingConstants";
import StripeCheckoutForm from "./StripeCheckoutForm";
import { Elements } from "@stripe/react-stripe-js";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY, {});

type Props = {
  setOpen: (open: boolean) => void;
  fetchPaymentMethods?: Function;
};

const StripeSetup: FC<Props> = ({ setOpen, fetchPaymentMethods }) => {
  const options = {
    mode: "setup" as "setup",
    currency: "usd",
  };

  return (
    <div style={{ maxHeight: "60vh", overflowY: "scroll" }}>
      <Elements stripe={stripePromise} options={options}>
        <StripeCheckoutForm fetchPaymentMethods={fetchPaymentMethods} setOpen={setOpen} />
      </Elements>
    </div>
  );
};
export default StripeSetup;
